import { onAuthStateChanged, signInAnonymously, User } from '@firebase/auth';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { auth } from '../api/firebase';

interface AuthFilterProps {
  autoSignInIfNotAuthed: boolean;
}

const AuthFilter: React.FC<AuthFilterProps> = ({ autoSignInIfNotAuthed, children }) => {
  const history = useHistory();
  const [isAuthed, setIsAuthed] = useState<boolean>(!!auth.currentUser);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
      if (!user) {
        autoSignInIfNotAuthed ? await signInAnonymously(auth) : history.push('/');
      };
      setIsAuthed(!!auth.currentUser);
    })
    return unsubscribe;
  }, [autoSignInIfNotAuthed, history]);

  return <>{isAuthed && children}</>;
};

export default AuthFilter;
